<div class="swiper-container swiper1">
    <div class="swiper-wrapper">
        <div class="swiper-slide swiper-slide1" *ngFor="let movie of similars" [ngStyle]="{
                'background-size': 'cover', 
                'background-image':'url(https://image.tmdb.org/t/p/w500' + movie.backdrop_path +')'
                }">
            <!-- <a [routerLink]="['/pelicula', movie.id ]" [title]="movie.title"> -->

            <h2 class="similar-title text-bold" (click)="botonClick( movie.id )"><strong>{{ movie.title }}</strong></h2>
            <!-- </a> -->
        </div>

    </div>
    <!-- Add Pagination -->
    <div class="swiper-pagination swiper-pagination1"></div>
    <!-- Add Arrows -->
    <div class="swiper-button-next swiper-button-next1"></div>
    <div class="swiper-button-prev swiper-button-prev1"></div>
    <!-- If we need scrollbar -->
    <div class="swiper-scrollbar swiper-scrollbar1"></div>
</div>